export const TIPO_SOLICITUD_ACTIVACION = "A";
export const TIPO_SOLICITUD_ACTIVACION_LABEL = "Solicitud de Activación";
export const TIPO_SOLICITUD_REACTIVACION = "X";
export const TIPO_SOLICITUD_REACTIVACION_LABEL = "Solicitud de Re-Activación";
export const TIPO_SOLICITUD_CANCELACION = "C";
export const TIPO_SOLICITUD_CANCELACION_LABEL = "Solicitud de Cancelación";

export const ESTATUS_PENDIENTE = "P";
export const ESTATUS_PENDIENTE_LABEL = "Pendiente";
export const ESTATUS_APROBADO = "A";
export const ESTATUS_APROBADO_LABEL = "Aprobado";
export const ESTATUS_RECHAZADO = "R";
export const ESTATUS_RECHAZADO_LABEL = "Rechazado";

export class SolicitudesCompaniaTenant {
    static get TIPO_SOLICITUD_TENANT() {
        return [
            {
                value: TIPO_SOLICITUD_ACTIVACION,
                label: TIPO_SOLICITUD_ACTIVACION_LABEL
            },
            {
                value: TIPO_SOLICITUD_CANCELACION,
                label: TIPO_SOLICITUD_CANCELACION_LABEL
            }
        ]
    }

    static get ESTATUS_SOLICITUD_TENANT() {
        return [
            {
                value: ESTATUS_PENDIENTE,
                label: ESTATUS_PENDIENTE_LABEL
            },
            {
                value: ESTATUS_APROBADO,
                label: ESTATUS_APROBADO_LABEL
            },
            {
                value: ESTATUS_RECHAZADO,
                label: ESTATUS_RECHAZADO_LABEL
            }
        ]
    }
}